<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="pageVocabs + 'title'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <!-- part 1 statues -->
        <section
          class="sm:tw-w-1/2 xl:tw-w-1/3"
          [class]="isShowForP2pOrDynamicSendType ? 'offset-xl-2' : ''"
        >
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              {{ pageVocabs + "selectDeliveryStatus" | translate }}
            </legend>

            <div class="tw-my-3">
              <div class="tw-w-full tw-mr-1 tw-mb-1">
                <span class="text-danger">*</span>
                <span class="tw-text-gray-700 dark:tw-text-gray-300">
                  {{ "common.aggregator" | translate }}
                </span>
              </div>

              <!-- smsAggregators -->

              <enum-chip-list-select-search
                enumName="SmsAggregator"
                [isShowSelectAll]="true"
                (onError)="onClose()"
                (valuesChange)="model.smsAggregators = $event"
              >
              </enum-chip-list-select-search>
            </div>

            <div class="tw-my-3">
              <div class="tw-w-full tw-mr-1 tw-mb-1">
                <span class="text-danger">*</span>
                <span class="tw-text-gray-700 dark:tw-text-gray-300">
                  {{ pageVocabs + "deliveryStatusRequiredMsg" | translate }}
                </span>
              </div>

              <!-- DeliveryStatus -->
              <div *ngIf="deliveryStatusData?.length > 0">
                <div class="tw-my-3 tw-pr-3 tw-flex tw-items-center">
                  <div class="checkbox-section">
                    <mat-checkbox
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="isSelectAllDeliveryStatus"
                      (change)="selectAllDeliveryStatus()"
                      class="example-margin"
                    >
                      {{ "common.selectAll" | translate }}
                    </mat-checkbox>
                  </div>
                </div>

                <mat-selection-list
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="selectedDeliveryStatus"
                  (ngModelChange)="selectedDeliveryStatus = $event"
                  class="tw-overflow-y-auto tw-h-[400px]"
                >
                  <div
                    class="tw-px-1 tw-pl-3"
                    *ngFor="let item of deliveryStatusData"
                  >
                    <mat-list-option
                      #option
                      class="tw-my-2 tw-bg-gray-50"
                      [value]="item.deliveryStatus"
                    >
                      <div class="tw-flex tw-justify-between tw-items-center">
                        <div
                          class="tw-text-wrap tw-leading-[16px]"
                          [innerHTML]="
                            item.deliveryStatus
                              | enumToText : deliveryStatusEnumValues
                          "
                        ></div>
                        <span
                          class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                          >{{ item.count | numberSeparator }}</span
                        >
                      </div>
                    </mat-list-option>
                  </div>
                </mat-selection-list>
              </div>
            </div>
          </fieldset>
        </section>

        <!-- part 2 messageInformation -->
        <section class="sm:tw-w-1/2 xl:tw-w-1/3">
          <fieldset class="tw-h-full tw-flex tw-flex-col">
            <legend class="tw-flex-center">
              {{ pageVocabs + "messageInformation" | translate }}
            </legend>

            <div class="row">
              <div class="md:tw-w-full">
                <list-group-item
                  [label]="'common.organizationName'"
                  [value]="organizationName"
                  valueMaxWidth="2xl:tw-max-w-[230px] xl:tw-max-w-[165px] md:tw-max-w-[500px] sm:tw-max-w-[420px] tw-max-w-[140px]"
                >
                </list-group-item>
              </div>
              <div class="md:tw-w-full">
                <list-group-item
                  [label]="'common.userName'"
                  [value]="userName"
                  valueMaxWidth="2xl:tw-max-w-[230px] xl:tw-max-w-[165px] md:tw-max-w-[500px] sm:tw-max-w-[420px] tw-max-w-[140px]"
                >
                </list-group-item>
              </div>
            </div>

            <div class="tw-my-3" *ngIf="!isShowForP2pOrDynamicSendType">
              <app-sms-body
                [form]="form"
                smsBodyControlName="smsBody"
                senderNumberControlName="senderNumberId"
                voiceMessageControlName="voiceMessageId"
                voiceMessageGroupIdControlName="voiceMessageGroupId"
                maxTryCountControlName="maxTryCount"
                minuteBetweenTriesControlName="minuteBetweenTries"
                [voiceMessageDetails]="voiceMessageDetail"
                [voiceMessageGroupId]="voiceMessageGroupId"
                [smsBody]="smsBody"
                [isCanSendVoice]="isCanSendVoice"
                [isAddSignature]="false"
                [isAddHeader]="false"
                [organizationId]="organizationId"
                [userId]="userId"
                [sendType]="sendType"
                (senderNumberId)="model.senderNumberId = $event"
                (senderNumber)="changeValidations($event?.isCanSendVoice)"
                (smsBody)="smsBody = $event"
                (finalSmsBody)="model.smsBody = $event"
                (voiceMessageDetails)="model.voiceMessageDetails = $event"
              >
              </app-sms-body>
              <!-- baseModel.isCanSendFlashSms = $event?.isCanSendFlashSms; -->
            </div>

            <ng-container *ngIf="isShowForP2pOrDynamicSendType">
              <div
                class="tw-mb-3 tw-flex flex-column tw-justify-between tw-h-full"
              >
                <div class="tw-px-1">
                  <!-- senderNumberId -->
                  <div class="tw-my-3">
                    <private-number-select-search
                      class="tw-w-full"
                      [organizationId]="organizationId"
                      [userId]="userId"
                      [control]="form?.get('senderNumberId')"
                      [isShowRefreshBtn]="true"
                      (valueChange)="model.senderNumberId = $event"
                    >
                    </private-number-select-search>
                  </div>

                  <!-- date time picker -->
                  <app-date-time-picker
                    [config]="directDateTimeConfig"
                    (dateTime)="model.sendDateTime = $event"
                  >
                  </app-date-time-picker>

                  <!-- isSendFromMyPanel -->
                  <div class="tw-w-full tw-pt-3">
                    <mat-slide-toggle
                      formControlName="isSendFromMyPanel"
                      (change)="changeIsSendFromMyPanel()"
                      [(ngModel)]="model.isSendFromMyPanel"
                    >
                      {{ pageVocabs + "isSendFromMyPanel" | translate }}
                    </mat-slide-toggle>
                  </div>
                </div>

                <!-- submit btn -->
                <button
                  type="button"
                  mat-ripple
                  class="btn tw-py-2 tw-w-full button-shadow btn-hover-rise"
                  [themeColor]="'btn-gradient'"
                  (click)="onSubmit()"
                  [disabled]="loading"
                >
                  <ng-container *ngIf="!loading">
                    {{ "common.sendSubmit" | translate }}
                    <i class="fas fa-paper-plane tw-text-2xl"></i>
                  </ng-container>

                  <ng-container *ngIf="loading">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </ng-container>
                </button>
              </div>
            </ng-container>
          </fieldset>
        </section>

        <!-- part 3 receivers and sendDateTime -->
        <section
          class="sm:tw-w-1/2 xl:tw-w-1/3"
          *ngIf="!isShowForP2pOrDynamicSendType"
        >
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              {{ pageVocabs + "receiversAndSendDateTime" | translate }}
            </legend>
            <div
              class="tw-mb-3 tw-flex flex-column tw-justify-between tw-h-full"
            >
              <div class="tw-px-1">
                <mat-accordion>
                  <!-- (1) sendDateTimeChecked -->
                  <mat-expansion-panel
                    (click)="onLogForm()"
                    [expanded]="isExpandDirectDateTime"
                    *ngIf="isShowDirectSend"
                    style="
                      border-radius: 5px !important;
                      margin-top: 10px !important;
                    "
                  >
                    <mat-expansion-panel-header
                      (click)="onChangeGradualChecked(false)"
                    >
                      <mat-panel-title>
                        <mat-radio-group formControlName="sendDateTimeChecked">
                          <mat-radio-button [checked]="!model.gradualChecked">
                            {{ pageVocabs + "sendDirect" | translate }}
                          </mat-radio-button>
                        </mat-radio-group>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <!-- date time picker -->
                    <app-date-time-picker
                      [config]="directDateTimeConfig"
                      (dateTime)="model.sendDateTime = $event"
                    >
                    </app-date-time-picker>
                  </mat-expansion-panel>

                  <!-- (3)gradualChecked -->
                  <mat-expansion-panel
                    (afterExpand)="onLogForm()"
                    [expanded]="isExpandGradualDateTime"
                    *ngIf="isShowGradualSend"
                    style="
                      border-radius: 5px !important;
                      margin-top: 10px !important;
                    "
                  >
                    <mat-expansion-panel-header
                      (click)="onChangeGradualChecked(true)"
                    >
                      <mat-panel-title>
                        <mat-radio-group formControlName="gradualChecked">
                          <mat-radio-button [checked]="model.gradualChecked">
                            {{ pageVocabs + "sendGradual" | translate }}
                          </mat-radio-button>
                        </mat-radio-group>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="row">
                      <!-- alert -->
                      <div class="md:tw-w-full tw-px-0">
                        <div class="alert alert-blue">
                          {{ "pages.baseSendSms.gradualAlert" | translate }}
                        </div>
                      </div>

                      <!--gradual date time picker -->
                      <app-date-time-picker
                        [config]="gradualDateTimeConfig"
                        (dateTime)="model.gradualStart = $event"
                      >
                      </app-date-time-picker>

                      <!-- gradualPeriodText -->
                      <div class="md:tw-w-1/2 tw-px-1">
                        <form-field
                          type="tel"
                          [hasNumberSeparator]="true"
                          [(value)]="model.gradualPeriodText"
                          [control]="form?.get('gradualPeriodText')"
                          [label]="'pages.baseSendSms.fields.everyFewMinutes'"
                          [min]="model.gradualChecked ? 1 : null"
                        >
                        </form-field>
                      </div>

                      <!-- gradualPageSize -->
                      <div class="md:tw-w-1/2 tw-px-1">
                        <form-field
                          type="tel"
                          [hasNumberSeparator]="true"
                          [control]="form?.get('gradualPageSize')"
                          [(value)]="model.gradualPageSize"
                          [label]="
                            'pages.baseSendSms.fields.numberOfSubmissions'
                          "
                          [min]="model.gradualChecked ? 1000 : null"
                          [step]="1000"
                        >
                        </form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>

                <!-- extraReceivers -->
                <div class="tw-flex-center flex-column tw-mt-5">
                  <div class="tw-w-full tw-mr-1 tw-mb-2">
                    <span class="text-danger">*</span>
                    <span
                      class="tw-text-gray-700 dark:tw-text-gray-300"
                      translate
                      [translateParams]="{ number: 5 }"
                    >
                      messages.maxReceiversMsg
                    </span>
                  </div>

                  <div class="tw-w-full">
                    <app-chip-list
                      [maxLength]="5"
                      [form]="form"
                      [title]="pageVocabs + 'extraReceivers'"
                      placeholder="messages.separateByCommaAndEnter"
                      [checkInputWhenBlur]="true"
                      (items)="receiversNumbers = $event"
                    >
                    </app-chip-list>
                  </div>
                </div>
                
                <!-- description -->
                <form-textarea
                  class="tw-w-full"
                  label="common.description"
                  [(value)]="model.description"
                  [control]="form?.get('description')"
                  [rows]="1"
                  (valueChange)="(model.description)"
                >
                </form-textarea>

                <!-- isSendFromMyPanel -->
                <div class="tw-w-full tw-pt-3">
                  <mat-slide-toggle
                    formControlName="isSendFromMyPanel"
                    (change)="changeIsSendFromMyPanel()"
                    [(ngModel)]="model.isSendFromMyPanel"
                  >
                    {{ pageVocabs + "isSendFromMyPanel" | translate }}
                  </mat-slide-toggle>
                </div>
              </div>

              <!-- submit btn -->
              <button
                type="button"
                mat-ripple
                class="btn tw-py-2 tw-mb-4 tw-w-full button-shadow btn-hover-rise"
                [themeColor]="'btn-gradient'"
                (click)="onSubmit()"
                [disabled]="loading"
              >
                <ng-container *ngIf="!loading">
                  {{ "common.sendSubmit" | translate }}
                  <i class="fas fa-paper-plane tw-text-2xl"></i>
                </ng-container>

                <ng-container *ngIf="loading">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </ng-container>
              </button>
            </div>
          </fieldset>
        </section>
      </div>
    </form>
  </div>
</app-page-body>
